import { fetchNewsFeed } from './general';

export default (id, start) => {
  const FEED_HOME = { id, dataType: 'posts' };
  const HOME_QUERIES = { size: 20, filter: 'user-newsfeed' };

  return fetchNewsFeed(FEED_HOME, HOME_QUERIES, start);
};



// WEBPACK FOOTER //
// ./~/virgo/src/actions/feedActionsCreator/home.js